/* Reader-safe edition projection -> existing Published Book presentation props.
 * No working draft content is read or copied into the published edition view.
 */
const clean = v => String(v ?? "").trim();
export function approvedReaderToPublishedBookProps(reader, baseUrl="") {
  if (!reader || reader.publication?.status !== "published_nextscenes" || !Array.isArray(reader.units))
    throw new Error("An approved reader projection is required");
  const units=reader.units.map(u=>({
    id:clean(u.unitId), unitType:clean(u.unitType)||"single_page",
    illustrationPageSide:clean(u.illustrationPageSide),
  }));
  if (new Set(units.map(x=>x.id)).size !== units.length || units.some(x=>!x.id))
    throw new Error("Published page identities are invalid");
  const entries=reader.units.map(u=>({
    unitId:clean(u.unitId),
    manuscriptText:u.manuscript?.format==="plain_text" ? clean(u.manuscript.text) : "",
    ...(u.manuscript?.format==="structured_v1" ?
      { manuscriptContent:u.manuscript.content } : {}),
  }));
  const projectPlan={
    identity:{title:clean(reader.title),penName:clean(reader.creator?.name)},
    coverPlan:{authorName:clean(reader.creator?.name)},
    bookMap:{units},manuscriptPlan:{entries},
    publicationReadiness:{status:"published_nextscenes",publishedAt:clean(reader.publication.publishedAt)},
  };
  const ids=new Set();const assets=[];
  function asset(ref,type,purpose,unitId="") {
    if(!ref?.available || !ref.assetId)return;
    const assetId=clean(ref.assetId);
    if (!/^[a-f0-9]{24}$/i.test(assetId) || ids.has(assetId))
      throw new Error("Published image identity invalid");
    ids.add(assetId);
    // Protected file loader receives this server-authorized URL and returns a blob.
    const url=`${clean(baseUrl).replace(/\/+$/,"")}/api/reader/childrens-book/${encodeURIComponent(reader.workId)}/assets/${encodeURIComponent(assetId)}`;
    assets.push({id:assetId,assetType:type,purpose,bookMapUnitId:unitId,
      status:"active",source:"upload",storageProvider:"local",publicUrl:url});
  }
  asset(reader.cover,"cover","front_cover");
  for(const u of reader.units)asset(u.illustration,"illustration","book_map_illustration",clean(u.unitId));
  return {projectPlan,childrensBookAssets:assets};
}
